import { IAppEnvironment } from '@pf/shared-common';

export const environment: IAppEnvironment = {
    production: true,
    environment: 'prod',
    mainUrl: 'https://demo.controltowerapp.com',
    auth0ClientId: 'tXGrgvUt6LZa3MNHz0LKteovkJ7j7Y8h',
    auth0AuthParams: {
        organization: 'org_SICdlPQopNUQ4PkJ',
        redirect_uri: 'https://demo.controltowerapp.com/public/login-callback',
    },
};
